import { Component } from '@angular/core'
import { isNullOrEmpty } from '@helios/utils'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import {
  CreateNewFilterGroupModalAction,
  CreateNewFilterGroupModalResponse,
} from './create-new-filter-group-modal.service'

const ALLOWED_CHARACTERS_PATTERN = /^[a-zA-Z0-9\s]*$/

@Component({
  selector: 'hs-create-new-filter-group-modal',
  templateUrl: './create-new-filter-group-modal.component.html',
})
export class CreateNewFilterGroupModalComponent {
  name = ''
  description = ''
  isSubmitEnabled = false
  nameError = ''
  descriptionError = ''

  constructor(readonly activeModal: NgbActiveModal) {}

  onSave() {
    this.close(CreateNewFilterGroupModalAction.SAVE)
  }
  onSaveAndApply() {
    this.close(CreateNewFilterGroupModalAction.SAVE_AND_APPLY)
  }

  updateIsSubmitEnabled() {
    this.validate()
    this.isSubmitEnabled =
      isNullOrEmpty(this.nameError) && isNullOrEmpty(this.descriptionError)
  }

  private validate() {
    this.nameError = ''
    this.descriptionError = ''
    if (isNullOrEmpty(this.name)) {
      this.nameError = 'Name is required.'
    } else if (
      !isNullOrEmpty(this.name) &&
      !ALLOWED_CHARACTERS_PATTERN.test(this.name)
    ) {
      this.nameError =
        'Name contains invalid characters. Only letters, numbers, and spaces are allowed.'
    }
    if (
      !isNullOrEmpty(this.description) &&
      !ALLOWED_CHARACTERS_PATTERN.test(this.description)
    ) {
      this.descriptionError =
        'Description contains invalid characters. Only letters, numbers, and spaces are allowed.'
    }
  }

  private close(action: CreateNewFilterGroupModalAction) {
    if (!this.isSubmitEnabled) return

    const response: CreateNewFilterGroupModalResponse = {
      name: this.name,
      description: this.description,
      action,
    }
    this.activeModal.close(response)
  }
}
